<template>
  <DialogBaseWhite :show="dialogUpdateMADTemplate.open" :title="$t('MADTemplate.updateMADTemplate') | capitalize" @on-close="closeDialogUpdateMADTemplate">
    <template v-slot:content>
      <MADTemplate @on-cancel="onCancel" @on-submit="onSubmit" :template="dialogUpdateMADTemplate.template"/>
    </template>
  </DialogBaseWhite>
</template>

<script>
import DialogBaseWhite from "components/dialog/base/DialogBaseWhite";
import MADTemplate from "components/form/MADTemplate";
import {mapActions, mapState} from "vuex";
export default {
  name: "DialogUpdateMADTemplate",
  components: {MADTemplate, DialogBaseWhite},
  computed: {
    ...mapState('dialog', ['dialogUpdateMADTemplate']),
  },
  methods: {
    ...mapActions('dialog', ['closeDialogUpdateMADTemplate']),
    ...mapActions('madTemplate', ['updateMADTemplate']),
    onCancel() {
      this.closeDialogUpdateMADTemplate()
    },
    onSubmit(form) {
      this.updateMADTemplate(form)
    }
  }
}
</script>

<style scoped>

</style>
